module.exports = __webpack_public_path__ + "img/brush.4b0da97e.svg";